import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../../../Shared/Utill/AuthUtil";

const DuplicateEventDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');

    useEffect(() => {
        dialog.show();
    }, []);

    const duplicateEventAction = () => {
        // call duplicate event  api
        console.log("request payload",props.eventId, props.eventName);
        callDuplicateService(props.eventId,props.eventName); 
    }

    const callDuplicateService = (eventid,evntName) =>{
       let data = {
        eventId: eventid,
        eventName: evntName
        };

       axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DUPLICATE_ADMIN_EVENT_CONTROLS_BY_EVENTID_NAME}`,
       data, {
        headers: {
          'content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
        .then((response) => {
         console.log("response is",response.data);
         if(response.status === 200){
          // success close popup
             props.onDuplicateCallback("success","Event duplicated successfully.",response.data );   
         }else{
            props.onDuplicateCallback("error","Something went wrong", response.data); 
         }
        })
        .catch((error) => {
           //catch
         props.onDuplicateCallback("error",error.response.data.message, "Error"); 
        })
    }
  
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    return (
        <Box>
            <Dialog
                open={dialog.open}
                title={"Confirm Duplicate Event"}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                        <Button onClick={() => duplicateEventAction()}>Yes</Button>
                    </>
                }
            >
                <Typography>{"Are you sure you want to duplicate this event along with all the included locations."}</Typography>
            </Dialog>
        </Box>
    );
}

export default DuplicateEventDialog;

